// extracted by mini-css-extract-plugin
export default {"whiteBoxWrapper":"WhiteBoxWrapper_whiteBoxWrapper__fAIE+"};